"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartClient } from "@sticker-giant/sg-frontend-common";
import { type MutationKey, useMutation } from "@tanstack/react-query";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";
type PaymentMutationParams<TInput, TOutput> = {
  mutationKey: MutationKey;
  method: (client: CartClient, cartId: string, input: TInput) => Promise<TOutput>;
  onSuccess?: (output: TOutput, input: TInput) => void;
};
export function usePaymentMutation(t0) {
  const $ = _c(8);
  const {
    mutationKey,
    method,
    onSuccess
  } = t0;
  const cartClient = useServicesStore(_temp);
  const cartId = useGlobalStore(_temp2);
  let t1;
  if ($[0] !== cartClient || $[1] !== cartId || $[2] !== method) {
    t1 = async input => {
      if (!cartClient) {
        throw new Error("Cart client is not available.");
      }
      if (!cartId) {
        throw new Error("Cart id is not available.");
      }
      return method(cartClient, cartId, input);
    };
    $[0] = cartClient;
    $[1] = cartId;
    $[2] = method;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== mutationKey || $[5] !== onSuccess || $[6] !== t1) {
    t2 = {
      mutationKey,
      mutationFn: t1,
      onSuccess
    };
    $[4] = mutationKey;
    $[5] = onSuccess;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useMutation(t2);
}
function _temp2(state_0) {
  return state_0.cartId;
}
function _temp(state) {
  return state.cartClient;
}